import React, { useState } from "react";
import {
  CAvatar,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownMenu,
  CDropdownToggle,
} from "@coreui/react";

import avatar8 from "./../../assets/images/avatars/no_avatar.png";
import { Link, useNavigate } from "react-router-dom";
import httpClient from "../../util/HttpClient";
import { Box, Button, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

const AppHeaderDropdown = () => {
  const [openModel, setModelOpen] = useState(false)
  const navigate = useNavigate();
  const adminName = localStorage.getItem("NetworkAdmin");

  const handleLogOut = async () => {
    console.log("logout")
    localStorage.removeItem("DreamToken"); //remove token from local storage
    navigate("/auth/login");
    // httpClient
    //   .get("/logout")
    //   .then((res) => {
    //     if (res.data.success) {
    //     }
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  };
  console.log("Admin", adminName);
  
  return (
    <>
      <Container>
        <Box sx={{ mt: 1 }}>
          <h3>{adminName}</h3>
        </Box>
      </Container>
      <CDropdown variant="nav-item">
        <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
          <CAvatar src={avatar8} size="md" />
        </CDropdownToggle>
        <CDropdownMenu className="pt-0" placement="bottom-end">
          <CDropdownHeader className="bg-light fw-semibold py-2">
            Account
          </CDropdownHeader>
          
          {/* <Link className="dropdown-item" to={"/web/profile"}>
          {" "}
          <i className="bi bi-person-square"></i>&nbsp;Profile
        </Link> */}
          {/* <Link className="dropdown-item" to={"/web/settings"}>
          {" "}
          <i className="bi bi-gear-fill"></i>&nbsp;Settings
        </Link> */}

          <CDropdownDivider />
          <Link
            className="dropdown-item"
            //  onClick={handleLogOut}
            onClick={() => setModelOpen(true)}
          >
            {" "}
            <i className="bi bi-box-arrow-right text-danger"></i>&nbsp;Log out
          </Link>
        </CDropdownMenu>
      </CDropdown>

      <Dialog
        open={openModel}
        onClose={() => setModelOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <DialogTitle id="alert-dialog-title">
          {"Use Google's location service?"}
        </DialogTitle> */}
        <DialogContent sx={{mt:3,mb:3 }}>
          <DialogContentText id="alert-dialog-description">
            <h3>Are you sure, you want to logout?</h3>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{mb:2}}>
          <Button onClick={() => setModelOpen(false)}>Cancel</Button>
          <Button onClick={handleLogOut} autoFocus>
            Logout
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AppHeaderDropdown;
